<div class="tag-details-view-container" *ngIf="blogTagObject" fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async).dobry_agent.write " (click)="modify()" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>
    <button
      (click)="deleteWeak(blogTagObject.uuid)"  mat-stroked-button >
      <mat-icon>archive</mat-icon>
      <span> Przenieś do archiwum</span>
    </button>
    <button
      (click)="delete(blogTagObject)"  mat-stroked-button color="warn">
      <mat-icon>delete</mat-icon>
      <span> Usuń</span>
    </button>
  </div>
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <app-section-header
          title="Dane tagu"
          description="Podstawowe informacje i ustawienia tagu."
        ></app-section-header>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100" >
            <app-detail  header="Nazwa tagu" [value]="blogTagObject.name"></app-detail>
          </div>
        </div>


        <div fxLayout="row" fxLayoutGap="15px">
          <app-detail
            fxFlex="100"
            header="Status"
          >
            <app-detail-bool
              [header]="blogTagObject.active ? 'Aktywny': 'Nieaktywny'"
              [value]="blogTagObject.active"></app-detail-bool>

          </app-detail>
        </div>
      </mat-card>

    </div>
  </div>

</div>
